import QrScanner from 'qr-scanner';
import {addSpinner} from '../shared/spinner'
import {removeSpinner} from '../shared/spinner'
import {confirmLocationThenSubmit} from '../shared/geolocation_capture'

const videoElem = document.getElementById('qr-scan-display');
const qrError = document.getElementById('qr-error');
const qrCode = document.getElementById('qr_code');
const form = document.getElementById('punch-form');

const qrScanner = new QrScanner(
    videoElem,
    result => send_login(result?.data),
    {
        onDecodeError: error => {
            qrError.textContent = error;
        },
        highlightScanRegion: true,
        highlightCodeOutline: true,
        maxScansPerSecond: 25
    },
);

document.addEventListener('DOMContentLoaded', () => {
    QrScanner.hasCamera()
        .then(result => start_camera(result))
        .catch(error => console.log(error || 'No Camera found.'));
});

function send_login(qr) {
    const spinner = addSpinner(qrCode)
    qrCode.value = qr?.trim();
    qrScanner.stop();
    confirmLocationThenSubmit(
        form,
        () => form.submit(),
        () => {
            removeSpinner(spinner);
            qrScanner.start().then().catch(error => console.log(error || 'Unable to Start Camera.'));
        }
    );
}

function start_camera(has_camera) {
    if (has_camera) {
        document.getElementById('qr-login').style.display = 'block';
        qrScanner.start()
            .then()
            .catch(error => console.log(error || 'Unable to Start Camera.'));
    }
}
